import {
  MsalGuardConfiguration,
  MsalInterceptorConfiguration,
} from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  InteractionType,
  IPublicClientApplication,
  LogLevel,
  PublicClientApplication,
} from '@azure/msal-browser';
import { environment } from '@environment';
import { Path } from '@shared-enums';

export function loggerCallback(logLevel: LogLevel, message: string): void {
  if (logLevel && message) {
    return;
  }
}

export function msalInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.AAD.clientId,
      authority: environment.AAD.authority,
      redirectUri: environment.AAD.redirectUri,
      postLogoutRedirectUri: environment.AAD.postLogoutRedirectUri,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
    },
    system: {
      allowNativeBroker: false,
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false,
      },
    },
  });
}

export function msalInterceptorConfig(): MsalInterceptorConfiguration {
  const protectedResourceMap = getProtectedResourcesMap();

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}

export function msalGuardConfig(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    loginFailedRoute: Path.Login,
    authRequest: {
      scopes: [],
    },
  };
}

export const getProtectedResourcesMap = (): Map<string, string[]> => {
  return new Map([
    ['https://graph.microsoft.com/v1.0/me', ['user.read']],
    [environment.apiUrl, [environment.AAD.scope]],
  ]);
};
